/*
 * Copyright (c) 2016-2022 Martin Donath <martin.donath@squidfunk.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { h } from "~/utilities"

import { renderTooltip } from "../tooltip"

/* ----------------------------------------------------------------------------
 * Functions
 * ------------------------------------------------------------------------- */

/**
 * Render an annotation
 *
 * @param id - Annotation identifier
 * @param prefix - Tooltip identifier prefix
 *
 * @returns Element
 */
export function renderAnnotation(
  id: string | number, prefix?: string
): HTMLElement {
  prefix = prefix ? `${prefix}_annotation_${id}` : undefined

  /* Render tooltip with anchor, if given */
  if (prefix) {
    const anchor = prefix ? `#${prefix}` : undefined
    return (
      <aside class="md-annotation" tabIndex={0}>
        {renderTooltip(prefix)}
        <a href={anchor} class="md-annotation__index" tabIndex={-1}>
          <span data-md-annotation-id={id}></span>
        </a>
      </aside>
    )
  } else {
    return (
      <aside class="md-annotation" tabIndex={0}>
        {renderTooltip(prefix)}
        <span class="md-annotation__index" tabIndex={-1}>
          <span data-md-annotation-id={id}></span>
        </span>
      </aside>
    )
  }
}
